/**
 * Blob/バイナリデータを Excel ファイルとしてダウンロードさせます。
 * 生成した Object URL はダウンロード開始直後に解放し、メモリリークを防ぎます。
 * @param data ダウンロード対象のデータ（APIレスポンスのBlobなど）
 * @param fileName 保存時のファイル名（例: 'lead_stages.xlsx'）
 */
const downloadExcel = (data: BlobPart, fileName: string): void => {
  const blob = new Blob([data], { type: 'application/octet-stream' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.click();
  window.URL.revokeObjectURL(url);
};

export {
  downloadExcel,
};
